module.exports = __webpack_public_path__ + "img/swan.f0083173.png";